import { render, staticRenderFns } from "./pagovirtual.vue?vue&type=template&id=0c56f9ee&scoped=true"
import script from "./pagovirtual.vue?vue&type=script&lang=js"
export * from "./pagovirtual.vue?vue&type=script&lang=js"
import style0 from "./pagovirtual.vue?vue&type=style&index=0&id=0c56f9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56f9ee",
  null
  
)

export default component.exports